import { useCallback, useEffect, useState } from 'react'

import { getPriceCompliance } from '@/api/clarityLens'
import { PriceComplianceModel } from '@/types/clarityLens'

type BarChartDataModel = {
  data: { name: string; value: number }[]
}

export default function usePriceCompliance(
  startDate: string,
  endDate: string,
  branches: string,
  itemName: string
) {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)
  const [priceComplianceChartData, setPriceComplianceChartData] =
    useState<BarChartDataModel>()

  const fetchAllData = useCallback(async () => {
    if (!itemName) {
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const response = await getPriceCompliance(
        branches,
        startDate,
        endDate,
        itemName
      )

      setPriceComplianceChartData(convertToBarChart(response))
    } catch (err) {
      setError(
        new Error(
          err instanceof Error ? err.message : 'An unknown error occurred'
        )
      )
    } finally {
      setLoading(false)
    }
  }, [branches, startDate, endDate, itemName])

  const refetch = useCallback(() => {
    console.log('Refetching sku breakdown information...')
    return fetchAllData()
  }, [fetchAllData])

  useEffect(() => {
    fetchAllData()
  }, [fetchAllData])

  return {
    priceComplianceChartData,
    loading,
    error,
    refetch,
  }
}

function convertToBarChart(
  priceCompData: PriceComplianceModel
): BarChartDataModel {
  const data = Object.entries(priceCompData).map(([name, value]) => ({
    name,
    value,
  }))

  return {
    data,
  }
}
